import { render, staticRenderFns } from "./Merge.vue?vue&type=template&id=1f2cb00b&scoped=true"
import script from "./Merge.vue?vue&type=script&lang=js"
export * from "./Merge.vue?vue&type=script&lang=js"
import style0 from "./Merge.vue?vue&type=style&index=0&id=1f2cb00b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2cb00b",
  null
  
)

export default component.exports